"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
exports.getBlockType = (el) => {
    const allAttributes = el.getAttributeNames();
    // Incase "qualified" attribute names need to be escaped, here is an example of how to do so: [_osys\\:hideable]
    const blockType = constants_1.BLOCK_TYPES.sort((a, b) => b.weight - a.weight).find(bt => {
        // osysAttr is the needle, and allAttributes is the haystack
        const blockTypeAttr = bt.attrs.find(needle => {
            if (typeof needle === 'string') {
                return el.getAttribute(needle) !== null;
            }
            // osys:field:10201203123192380912
            return allAttributes.find(haystackItem => {
                return needle.test(haystackItem);
            });
        });
        if (blockTypeAttr) {
            return true;
        }
        return false;
    });
    return blockType ? blockType.type : 'unknown';
};
//# sourceMappingURL=getBlockType.js.map